export const FUNCTION_NAMES = {
  claimBillingPromoCode: "claimBillingPromoCodeV2",
  getMyBillingPromoStatus: "getMyBillingPromoStatusV2",
  checkTeamQuotaAllowance: "checkTeamQuotaAllowanceV2",
  confirmTrackedUploadFinalize: "confirmTrackedUploadFinalizeV2",
  reconcileTeamQuota: "reconcileTeamQuotaV2",
  beginOversizedVideoProcessing: "beginOversizedVideoProcessingV2",
  refreshVideoProcessingStatus: "refreshVideoProcessingStatusV2",
  createLiveLobby: "createLiveLobbyV2",
  joinLiveLobby: "joinLiveLobbyV2",
  heartbeatLiveLobby: "heartbeatLiveLobbyV2",
  commitLiveLobbySegment: "commitLiveLobbySegmentV2",
  ackLiveLobbySegmentPlayback: "ackLiveLobbySegmentPlaybackV2",
  leaveLiveLobby: "leaveLiveLobbyV2",
  endLiveLobby: "endLiveLobbyV2",
  joinTeamByInvite: "joinTeamByInviteV2",
  getTeamInvitePreview: "getTeamInvitePreviewV2",
  getResolvedAccess: "getResolvedAccessV2",
  getTeamBillingSetup: "getTeamBillingSetupV2",
  createTeam: "createTeamV2",
  selectTeamPlan: "selectTeamPlanV2",
  saveTeamPayers: "saveTeamPayersV2",
  approveTeamPayer: "approveTeamPayerV2",
  revokeTeamPayerApproval: "revokeTeamPayerApprovalV2",
  removeTeamPayerApproval: "removeTeamPayerApprovalV2",
  markMyPayerPaymentMethodReady: "markMyPayerPaymentMethodReadyV2",
  createPendingJoinProratePayment: "createPendingJoinProratePaymentV2",
  finalizePendingJoinProratePayment: "finalizePendingJoinProratePaymentV2",
  saveMyVerifiedPhone: "saveMyVerifiedPhoneV2",
  checkPhoneVerificationEligibility: "checkPhoneVerificationEligibilityV2",
  getMyBillingOverview: "getMyBillingOverviewV2",
  getMyBillingHistory: "getMyBillingHistoryV2",
  getMyPayerActionAlerts: "getMyPayerActionAlertsV2",
  cancelMyTeamSubscriptionRenewal: "cancelMyTeamSubscriptionRenewalV2",
  disconnectMyPayerCard: "disconnectMyPayerCardV2",
  completeTeamPaymentSetup: "completeTeamPaymentSetupV2",
  processTeamRenewal: "processTeamRenewalV2",
  updateTeamMemberRole: "updateTeamMemberRoleV2",
  setTeamProfilePermission: "setTeamProfilePermissionV2",
  setTeamRolePermission: "setTeamRolePermissionV2",
  teamModerateMember: "teamModerateMemberV2",
  transferTeamLeadership: "transferTeamLeadershipV2",
  requestTeamDisband: "requestTeamDisbandV2",
  cancelTeamDisband: "cancelTeamDisbandV2",
  saveStratsPlannerMediaLibraryManifest: "saveStratsPlannerMediaLibraryManifestV2",
  publishPlannerGuideMedia: "publishPlannerGuideMediaV2",
  publishPublicClip: "publishPublicClipV2",
  updatePublicClip: "updatePublicClipV2",
  deletePublicClip: "deletePublicClipV2",
};
